
/**
 * Copyright (c) 2018 Microsoft Corporation
 * Modules Registration
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

const universal = require('react-universal-component').default;

/**
 * Register all available modules
 */
export const registerAllModules = (requiredModules) => {
    let binding = { modules: {}, dataActions: {} };
    const { log, error }  = console;
    const detailedWebpackError = (msg, errorObject) => { error(msg); error(errorObject); process.env.NODE_ENV !== 'development' && error('Run in dev mode to see full list of errors'); process.exit(50); }
    const handleError = (modPath, errObject) => {
        detailedWebpackError('Error with path: ' + modPath, errObject);
    }
    if (requiredModules) {
        requiredModules = requiredModules.map((module) => module.toLowerCase());
    }
    const isNotRegistered = (moduleName) => {
        return !requiredModules || requiredModules.length <= 0 || requiredModules.findIndex((module) => module === moduleName) !== -1;
    };

    try {


    isNotRegistered('aad-generic') && (binding.modules['aad-generic'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/aad-generic/aad-generic'),
            {
                chunkName: () => '@msdyn365-commerce-modules-account-management-dist-lib-modules-aad-generic-aad-generic',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/aad-generic/aad-generic.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'aad-generic',
        packageName: 'account-management',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/aad-generic'
    });
            

    isNotRegistered('accordion') && (binding.modules['accordion'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/accordion/dist/lib/modules/accordion/accordion'),
            {
                chunkName: () => '@msdyn365-commerce-modules-accordion-dist-lib-modules-accordion-accordion',
                ignoreBabelRename: true
            }
        ),
        $type: 'moduleDefinition',
        dataActions: [{name:'accordionExpandedState',  path:'@msdyn365-commerce-modules/accordion/dist/lib/data-actions/accordion-state-data-action', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/accordion/dist/lib/modules/accordion/accordion.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'accordion',
        packageName: 'accordion',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/accordion/dist/lib/modules/accordion'
    });
            

    isNotRegistered('accordion-item') && (binding.modules['accordion-item'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/accordion/dist/lib/modules/accordion-item/accordion-item'),
            {
                chunkName: () => '@msdyn365-commerce-modules-accordion-dist-lib-modules-accordion-item-accordion-item',
                ignoreBabelRename: true
            }
        ),
        $type: 'moduleDefinition',
        dataActions: [{name:'accordionExpandedState',  path:'@msdyn365-commerce-modules/accordion/dist/lib/data-actions/accordion-state-data-action', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/accordion/dist/lib/modules/accordion-item/accordion-item.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'accordion-item',
        packageName: 'accordion',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/accordion/dist/lib/modules/accordion-item'
    });
            

    isNotRegistered('account-address-tile') && (binding.modules['account-address-tile'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-address-tile/account-address-tile'),
            {
                chunkName: () => '@msdyn365-commerce-modules-account-management-dist-lib-modules-account-address-tile-account-address-tile',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'address',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-address', runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/account-address-tile/account-address-tile.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'account-address-tile',
        packageName: 'account-management',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/account-address-tile'
    });
            

    isNotRegistered('account-customer-balance') && (binding.modules['account-customer-balance'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-customer-balance/account-customer-balance'),
            {
                chunkName: () => '@msdyn365-commerce-modules-account-management-dist-lib-modules-account-customer-balance-account-customer-balance',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'b2bUserInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-business-partner-user', runOn: 0},{name:'balance',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance', runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/account-customer-balance/account-customer-balance.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'account-customer-balance',
        packageName: 'account-management',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/account-customer-balance'
    });
            

    isNotRegistered('account-customer-balance-tile') && (binding.modules['account-customer-balance-tile'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-customer-balance-tile/account-customer-balance-tile'),
            {
                chunkName: () => '@msdyn365-commerce-modules-account-management-dist-lib-modules-account-customer-balance-tile-account-customer-balance-tile',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'balance',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance', runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/account-customer-balance-tile/account-customer-balance-tile.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'account-customer-balance-tile',
        packageName: 'account-management',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/account-customer-balance-tile'
    });
            

    isNotRegistered('account-generic-tile') && (binding.modules['account-generic-tile'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-generic-tile/account-generic-tile'),
            {
                chunkName: () => '@msdyn365-commerce-modules-account-management-dist-lib-modules-account-generic-tile-account-generic-tile',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/account-generic-tile/account-generic-tile.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'account-generic-tile',
        packageName: 'account-management',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/account-generic-tile'
    });
            

    isNotRegistered('account-invoice-tile') && (binding.modules['account-invoice-tile'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-invoice-tile/account-invoice-tile'),
            {
                chunkName: () => '@msdyn365-commerce-modules-account-management-dist-lib-modules-account-invoice-tile-account-invoice-tile',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'customerBalance',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance', runOn: 0},{name:'invoices',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/invoices/get-invoices', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/account-invoice-tile/account-invoice-tile.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'account-invoice-tile',
        packageName: 'account-management',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/account-invoice-tile'
    });
            

    isNotRegistered('account-loyalty') && (binding.modules['account-loyalty'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-loyalty/account-loyalty'),
            {
                chunkName: () => '@msdyn365-commerce-modules-account-management-dist-lib-modules-account-loyalty-account-loyalty',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'loyaltyCard',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/account-loyalty/account-loyalty.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'account-loyalty',
        packageName: 'account-management',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/account-loyalty'
    });
            

    isNotRegistered('account-loyalty-tile') && (binding.modules['account-loyalty-tile'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-loyalty-tile/account-loyalty-tile'),
            {
                chunkName: () => '@msdyn365-commerce-modules-account-management-dist-lib-modules-account-loyalty-tile-account-loyalty-tile',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'loyaltyCard',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/account-loyalty-tile/account-loyalty-tile.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'account-loyalty-tile',
        packageName: 'account-management',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/account-loyalty-tile'
    });
            

    isNotRegistered('account-management-address') && (binding.modules['account-management-address'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/address/dist/lib/modules/account-management-address/account-management-address'),
            {
                chunkName: () => '@msdyn365-commerce-modules-address-dist-lib-modules-account-management-address-account-management-address',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'address',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-address', runOn: 0},{name:'addressPurposes',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes', runOn: 0},{name:'countryRegions',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions', runOn: 0},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/address/dist/lib/modules/account-management-address/account-management-address.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'account-management-address',
        packageName: 'address',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/address/dist/lib/modules/account-management-address'
    });
            

    isNotRegistered('account-order-templates-tile') && (binding.modules['account-order-templates-tile'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-order-templates-tile/account-order-templates-tile'),
            {
                chunkName: () => '@msdyn365-commerce-modules-account-management-dist-lib-modules-account-order-templates-tile-account-order-templates-tile',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'orderTemplates',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/order-templates/get-order-templates', runOn: 1}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/account-order-templates-tile/account-order-templates-tile.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'account-order-templates-tile',
        packageName: 'account-management',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/account-order-templates-tile'
    });
            

    isNotRegistered('account-profile') && (binding.modules['account-profile'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-profile/account-profile'),
            {
                chunkName: () => '@msdyn365-commerce-modules-account-management-dist-lib-modules-account-profile-account-profile',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'attributeDefinitions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-attribute-definitions', runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/account-profile/account-profile.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'account-profile',
        packageName: 'account-management',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/account-profile'
    });
            

    isNotRegistered('account-profile-edit') && (binding.modules['account-profile-edit'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-profile-edit/account-profile-edit'),
            {
                chunkName: () => '@msdyn365-commerce-modules-account-management-dist-lib-modules-account-profile-edit-account-profile-edit',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/account-profile-edit/account-profile-edit.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'account-profile-edit',
        packageName: 'account-management',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/account-profile-edit'
    });
            

    isNotRegistered('account-welcome-tile') && (binding.modules['account-welcome-tile'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-welcome-tile/account-welcome-tile'),
            {
                chunkName: () => '@msdyn365-commerce-modules-account-management-dist-lib-modules-account-welcome-tile-account-welcome-tile',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'accountInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/account-welcome-tile/account-welcome-tile.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'account-welcome-tile',
        packageName: 'account-management',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/account-welcome-tile'
    });
            

    isNotRegistered('account-wishlist-tile') && (binding.modules['account-wishlist-tile'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-wishlist-tile/account-wishlist-tile'),
            {
                chunkName: () => '@msdyn365-commerce-modules-account-management-dist-lib-modules-account-wishlist-tile-account-wishlist-tile',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'wishlists',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/account-wishlist-tile/account-wishlist-tile.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'account-wishlist-tile',
        packageName: 'account-management',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/account-wishlist-tile'
    });
            

    isNotRegistered('active-image') && (binding.modules['active-image'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/active-image/dist/lib/modules/active-image/active-image'),
            {
                chunkName: () => '@msdyn365-commerce-modules-active-image-dist-lib-modules-active-image-active-image',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'products',  path:'@msdyn365-commerce-modules/active-image/dist/lib/modules/actions/get-active-image-products', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/active-image/dist/lib/modules/active-image/active-image.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'active-image',
        packageName: 'active-image',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/active-image/dist/lib/modules/active-image'
    });
            

    isNotRegistered('b2b-requests-status') && (binding.modules['b2b-requests-status'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/b2b-requests-status/b2b-requests-status'),
            {
                chunkName: () => '@msdyn365-commerce-modules-account-management-dist-lib-modules-b2b-requests-status-b2b-requests-status',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'b2bUserInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-business-partner-user', runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'operationRequests',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-business-partner-operation-requests', runOn: 1}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/b2b-requests-status/b2b-requests-status.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'b2b-requests-status',
        packageName: 'account-management',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/b2b-requests-status'
    });
            

    isNotRegistered('b2b-requests-tile') && (binding.modules['b2b-requests-tile'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/b2b-requests-tile/b2b-requests-tile'),
            {
                chunkName: () => '@msdyn365-commerce-modules-account-management-dist-lib-modules-b2b-requests-tile-b2b-requests-tile',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/b2b-requests-tile/b2b-requests-tile.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'b2b-requests-tile',
        packageName: 'account-management',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/b2b-requests-tile'
    });
            

    isNotRegistered('back-top-footer') && (binding.modules['back-top-footer'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/footer/dist/lib/modules/back-top-footer/back-top-footer'),
            {
                chunkName: () => '@msdyn365-commerce-modules-footer-dist-lib-modules-back-top-footer-back-top-footer',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/footer/dist/lib/modules/back-top-footer/back-top-footer.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'back-top-footer',
        packageName: 'footer',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/footer/dist/lib/modules/back-top-footer'
    });
            

    isNotRegistered('breadcrumb') && (binding.modules['breadcrumb'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/breadcrumb/dist/lib/modules/breadcrumb/breadcrumb'),
            {
                chunkName: () => '@msdyn365-commerce-modules-breadcrumb-dist-lib-modules-breadcrumb-breadcrumb',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'categoryHierarchy',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category-hierarchy', runOn: 0},{name:'categoryPaths',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-category-paths', runOn: 0},{name:'product',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/breadcrumb/dist/lib/modules/breadcrumb/breadcrumb.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'breadcrumb',
        packageName: 'breadcrumb',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/breadcrumb/dist/lib/modules/breadcrumb'
    });
            

    isNotRegistered('business-account-address') && (binding.modules['business-account-address'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/address/dist/lib/modules/business-account-address/business-account-address'),
            {
                chunkName: () => '@msdyn365-commerce-modules-address-dist-lib-modules-business-account-address-business-account-address',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'address',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-address', runOn: 0},{name:'addressPurposes',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes', runOn: 0},{name:'countryRegions',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions', runOn: 0},{name:'countryStates',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/address/dist/lib/modules/business-account-address/business-account-address.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'business-account-address',
        packageName: 'address',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/address/dist/lib/modules/business-account-address'
    });
            

    isNotRegistered('business-organization-list') && (binding.modules['business-organization-list'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/business-organization-list/dist/lib/modules/business-organization-list/business-organization-list'),
            {
                chunkName: () => '@msdyn365-commerce-modules-business-organization-list-dist-lib-modules-business-organization-list-business-organization-list',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'users',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-organization-users', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/business-organization-list/dist/lib/modules/business-organization-list/business-organization-list.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'business-organization-list',
        packageName: 'business-organization-list',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/business-organization-list/dist/lib/modules/business-organization-list'
    });
            

    isNotRegistered('business-sign-up') && (binding.modules['business-sign-up'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/business-account-management/dist/lib/modules/business-sign-up/business-sign-up'),
            {
                chunkName: () => '@msdyn365-commerce-modules-business-account-management-dist-lib-modules-business-sign-up-business-sign-up',
                ignoreBabelRename: true
            }
        ),
        $type: 'containerModule',
        dataActions: [],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/business-account-management/dist/lib/modules/business-sign-up/business-sign-up.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'business-sign-up',
        packageName: 'business-account-management',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/business-account-management/dist/lib/modules/business-sign-up'
    });
            

    isNotRegistered('buybox') && (binding.modules['buybox'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/buybox/dist/lib/modules/buybox/buybox'),
            {
                chunkName: () => '@msdyn365-commerce-modules-buybox-dist-lib-modules-buybox-buybox',
                ignoreBabelRename: true
            }
        ),
        $type: 'containerModule',
        dataActions: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'deliveryOptions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-selected-variant', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'orderTemplates',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/order-templates/get-order-templates-preview', runOn: 1},{name:'product',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 0},{name:'productAvailableQuantity',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-product-availabilities-for-selected-variant', runOn: 0},{name:'productDimensions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-dimensions-for-selected-variant', runOn: 0},{name:'productPrice',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-price-for-selected-variant', runOn: 0},{name:'ratingsSummary',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-ratings-summary', runOn: 1},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 0},{name:'wishlists',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/buybox/dist/lib/modules/buybox/buybox.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'buybox',
        packageName: 'buybox',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/buybox/dist/lib/modules/buybox'
    });
            

    isNotRegistered('carousel') && (binding.modules['carousel'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/carousel/dist/lib/modules/carousel/carousel'),
            {
                chunkName: () => '@msdyn365-commerce-modules-carousel-dist-lib-modules-carousel-carousel',
                ignoreBabelRename: true
            }
        ),
        $type: 'containerModule',
        dataActions: [],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/carousel/dist/lib/modules/carousel/carousel.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'carousel',
        packageName: 'carousel',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/carousel/dist/lib/modules/carousel'
    });
            

    isNotRegistered('cart') && (binding.modules['cart'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/cart/dist/lib/modules/cart/cart'),
            {
                chunkName: () => '@msdyn365-commerce-modules-cart-dist-lib-modules-cart-cart',
                ignoreBabelRename: true
            }
        ),
        $type: 'containerModule',
        dataActions: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'deliveryOptions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'orderTemplates',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/order-templates/get-order-templates-preview', runOn: 1},{name:'orgUnitLocations',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations', runOn: 0},{name:'productAvailabilites',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-availabilities-cartlines', runOn: 0},{name:'products',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-products-in-active-cart', runOn: 0},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 0},{name:'wishlistItems',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-items-in-wishlist', runOn: 1},{name:'wishlists',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id', runOn: 1}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/cart/dist/lib/modules/cart/cart.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'cart',
        packageName: 'cart',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/cart/dist/lib/modules/cart'
    });
            

    isNotRegistered('cart-icon') && (binding.modules['cart-icon'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/cart/dist/lib/modules/cart-icon/cart-icon'),
            {
                chunkName: () => '@msdyn365-commerce-modules-cart-dist-lib-modules-cart-icon-cart-icon',
                ignoreBabelRename: true
            }
        ),
        $type: 'containerModule',
        dataActions: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/get-cart-state-data-action', runOn: 1},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'orgUnitLocations',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/cart/dist/lib/modules/cart-icon/cart-icon.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'cart-icon',
        packageName: 'cart',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/cart/dist/lib/modules/cart-icon'
    });
            

    isNotRegistered('category-page-summary') && (binding.modules['category-page-summary'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/page-summary/dist/lib/modules/default-page-summary/default-page-summary'),
            {
                chunkName: () => '@msdyn365-commerce-modules-page-summary-dist-lib-modules-default-page-summary-default-page-summary',
                ignoreBabelRename: true
            }
        ),
        $type: 'htmlHeadTagsModule',
        dataActions: [{name:'pageSummary',  path:'@msdyn365-commerce-modules/page-summary/dist/lib/modules/category-page-summary/category-page-summary.action', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/page-summary/dist/lib/modules/category-page-summary/category-page-summary.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'category-page-summary',
        packageName: 'page-summary',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/page-summary/dist/lib/modules/category-page-summary'
    });
            

    isNotRegistered('check-in-for-pickup') && (binding.modules['check-in-for-pickup'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/check-in-for-pickup/dist/lib/modules/check-in-for-pickup/check-in-for-pickup'),
            {
                chunkName: () => '@msdyn365-commerce-modules-check-in-for-pickup-dist-lib-modules-check-in-for-pickup-check-in-for-pickup',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/check-in-for-pickup/dist/lib/modules/check-in-for-pickup/check-in-for-pickup.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'check-in-for-pickup',
        packageName: 'check-in-for-pickup',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/check-in-for-pickup/dist/lib/modules/check-in-for-pickup'
    });
            

    isNotRegistered('checkout') && (binding.modules['checkout'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout/checkout'),
            {
                chunkName: () => '@msdyn365-commerce-modules-checkout-dist-lib-modules-checkout-checkout',
                ignoreBabelRename: true
            }
        ),
        $type: 'containerModule',
        dataActions: [{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'deliveryOptions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines', runOn: 1},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'orgUnitLocations',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations', runOn: 1},{name:'products',  path:'@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout/actions/get-products-in-active-checkout-cart', runOn: 1}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout/checkout.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'checkout',
        packageName: 'checkout',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout'
    });
            

    isNotRegistered('checkout-billing-address') && (binding.modules['checkout-billing-address'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/address/dist/lib/modules/checkout-billing-address/checkout-billing-address'),
            {
                chunkName: () => '@msdyn365-commerce-modules-address-dist-lib-modules-checkout-billing-address-checkout-billing-address',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'addressPurposes',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes', runOn: 0},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'countryRegions',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions', runOn: 0},{name:'countryStates',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/address/dist/lib/modules/checkout-billing-address/checkout-billing-address.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'checkout-billing-address',
        packageName: 'address',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/address/dist/lib/modules/checkout-billing-address'
    });
            

    isNotRegistered('checkout-customer-account-payment') && (binding.modules['checkout-customer-account-payment'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-customer-account-payment/checkout-customer-account-payment'),
            {
                chunkName: () => '@msdyn365-commerce-modules-checkout-dist-lib-modules-checkout-customer-account-payment-checkout-customer-account-payment',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'creditBalances',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance', runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-customer-account-payment/checkout-customer-account-payment.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'checkout-customer-account-payment',
        packageName: 'checkout',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-customer-account-payment'
    });
            

    isNotRegistered('checkout-delivery-options') && (binding.modules['checkout-delivery-options'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-delivery-options/checkout-delivery-options'),
            {
                chunkName: () => '@msdyn365-commerce-modules-checkout-dist-lib-modules-checkout-delivery-options-checkout-delivery-options',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-delivery-options/checkout-delivery-options.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'checkout-delivery-options',
        packageName: 'checkout',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-delivery-options'
    });
            

    isNotRegistered('checkout-gift-card') && (binding.modules['checkout-gift-card'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-gift-card/checkout-gift-card'),
            {
                chunkName: () => '@msdyn365-commerce-modules-checkout-dist-lib-modules-checkout-gift-card-checkout-gift-card',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-gift-card/checkout-gift-card.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'checkout-gift-card',
        packageName: 'checkout',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-gift-card'
    });
            

    isNotRegistered('checkout-guest-profile') && (binding.modules['checkout-guest-profile'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-guest-profile/checkout-guest-profile'),
            {
                chunkName: () => '@msdyn365-commerce-modules-checkout-dist-lib-modules-checkout-guest-profile-checkout-guest-profile',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 1},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-guest-profile/checkout-guest-profile.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'checkout-guest-profile',
        packageName: 'checkout',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-guest-profile'
    });
            

    isNotRegistered('checkout-loyalty') && (binding.modules['checkout-loyalty'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-loyalty/checkout-loyalty'),
            {
                chunkName: () => '@msdyn365-commerce-modules-checkout-dist-lib-modules-checkout-loyalty-checkout-loyalty',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'loyaltyCard',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card', runOn: 1},{name:'loyaltyTransactionEstimation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-transaction-estimation', runOn: 1}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-loyalty/checkout-loyalty.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'checkout-loyalty',
        packageName: 'checkout',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-loyalty'
    });
            

    isNotRegistered('checkout-order-confirmation') && (binding.modules['checkout-order-confirmation'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/order-management/dist/lib/modules/checkout-order-confirmation/checkout-order-confirmation'),
            {
                chunkName: () => '@msdyn365-commerce-modules-order-management-dist-lib-modules-checkout-order-confirmation-checkout-order-confirmation',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'loyaltyCard',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card', runOn: 1},{name:'tenderTypes',  path:'@msdyn365-commerce-modules/order-management/dist/lib/actions/get-tender-types', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/order-management/dist/lib/modules/checkout-order-confirmation/checkout-order-confirmation.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'checkout-order-confirmation',
        packageName: 'order-management',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/order-management/dist/lib/modules/checkout-order-confirmation'
    });
            

    isNotRegistered('checkout-payment-instrument') && (binding.modules['checkout-payment-instrument'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-payment-instrument/checkout-payment-instrument'),
            {
                chunkName: () => '@msdyn365-commerce-modules-checkout-dist-lib-modules-checkout-payment-instrument-checkout-payment-instrument',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'cardPaymentAcceptPoint',  path:'@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-payment-instrument/actions/get-card-payment-accept-point', runOn: 1},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-payment-instrument/checkout-payment-instrument.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'checkout-payment-instrument',
        packageName: 'checkout',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-payment-instrument'
    });
            

    isNotRegistered('checkout-pickup') && (binding.modules['checkout-pickup'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-pickup/checkout-pickup'),
            {
                chunkName: () => '@msdyn365-commerce-modules-checkout-dist-lib-modules-checkout-pickup-checkout-pickup',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'deliveryOptions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'orgUnitLocations',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations', runOn: 1}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-pickup/checkout-pickup.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'checkout-pickup',
        packageName: 'checkout',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-pickup'
    });
            

    isNotRegistered('checkout-section-container') && (binding.modules['checkout-section-container'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-section-container/checkout-section-container'),
            {
                chunkName: () => '@msdyn365-commerce-modules-checkout-dist-lib-modules-checkout-section-container-checkout-section-container',
                ignoreBabelRename: true
            }
        ),
        $type: 'containerModule',
        dataActions: [{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-section-container/checkout-section-container.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'checkout-section-container',
        packageName: 'checkout',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-section-container'
    });
            

    isNotRegistered('checkout-shipping-address') && (binding.modules['checkout-shipping-address'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/address/dist/lib/modules/checkout-shipping-address/checkout-shipping-address'),
            {
                chunkName: () => '@msdyn365-commerce-modules-address-dist-lib-modules-checkout-shipping-address-checkout-shipping-address',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'address',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-address', runOn: 0},{name:'addressPurposes',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes', runOn: 0},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'countryRegions',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions', runOn: 0},{name:'countryStates',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/address/dist/lib/modules/checkout-shipping-address/checkout-shipping-address.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'checkout-shipping-address',
        packageName: 'address',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/address/dist/lib/modules/checkout-shipping-address'
    });
            

    isNotRegistered('checkout-terms-and-conditions') && (binding.modules['checkout-terms-and-conditions'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-terms-and-conditions/checkout-terms-and-conditions'),
            {
                chunkName: () => '@msdyn365-commerce-modules-checkout-dist-lib-modules-checkout-terms-and-conditions-checkout-terms-and-conditions',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-terms-and-conditions/checkout-terms-and-conditions.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'checkout-terms-and-conditions',
        packageName: 'checkout',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-terms-and-conditions'
    });
            

    isNotRegistered('content-block') && (binding.modules['content-block'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/content-block/dist/lib/modules/content-block/content-block'),
            {
                chunkName: () => '@msdyn365-commerce-modules-content-block-dist-lib-modules-content-block-content-block',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/content-block/dist/lib/modules/content-block/content-block.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'content-block',
        packageName: 'content-block',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/content-block/dist/lib/modules/content-block'
    });
            

    isNotRegistered('cookie-compliance') && (binding.modules['cookie-compliance'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/cookie-compliance/dist/lib/modules/cookie-compliance/cookie-compliance'),
            {
                chunkName: () => '@msdyn365-commerce-modules-cookie-compliance-dist-lib-modules-cookie-compliance-cookie-compliance',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/cookie-compliance/dist/lib/modules/cookie-compliance/cookie-compliance.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'cookie-compliance',
        packageName: 'cookie-compliance',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/cookie-compliance/dist/lib/modules/cookie-compliance'
    });
            

    isNotRegistered('country-picker') && (binding.modules['country-picker'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/country-picker/dist/lib/modules/country-picker/country-picker'),
            {
                chunkName: () => '@msdyn365-commerce-modules-country-picker-dist-lib-modules-country-picker-country-picker',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/country-picker/dist/lib/modules/country-picker/country-picker.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'country-picker',
        packageName: 'country-picker',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/country-picker/dist/lib/modules/country-picker'
    });
            

    isNotRegistered('default-container') && (binding.modules['default-container'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/core-components/dist/lib/modules/default-container/default-container'),
            {
                chunkName: () => '@msdyn365-commerce-modules-core-components-dist-lib-modules-default-container-default-container',
                ignoreBabelRename: true
            }
        ),
        $type: 'containerModule',
        dataActions: [],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/core-components/dist/lib/modules/default-container/default-container.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'default-container',
        packageName: 'core-components',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/core-components/dist/lib/modules/default-container'
    });
            

    isNotRegistered('default-container-2-slots') && (binding.modules['default-container-2-slots'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/core-components/dist/lib/modules/default-container-2-slots/default-container-2-slots'),
            {
                chunkName: () => '@msdyn365-commerce-modules-core-components-dist-lib-modules-default-container-2-slots-default-container-2-slots',
                ignoreBabelRename: true
            }
        ),
        $type: 'containerModule',
        dataActions: [],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/core-components/dist/lib/modules/default-container-2-slots/default-container-2-slots.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'default-container-2-slots',
        packageName: 'core-components',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/core-components/dist/lib/modules/default-container-2-slots'
    });
            

    isNotRegistered('default-container-3-slots') && (binding.modules['default-container-3-slots'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/core-components/dist/lib/modules/default-container-3-slots/default-container-3-slots'),
            {
                chunkName: () => '@msdyn365-commerce-modules-core-components-dist-lib-modules-default-container-3-slots-default-container-3-slots',
                ignoreBabelRename: true
            }
        ),
        $type: 'containerModule',
        dataActions: [],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/core-components/dist/lib/modules/default-container-3-slots/default-container-3-slots.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'default-container-3-slots',
        packageName: 'core-components',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/core-components/dist/lib/modules/default-container-3-slots'
    });
            

    isNotRegistered('default-external-script') && (binding.modules['default-external-script'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/core-components/dist/lib/modules/default-external-script/default-external-script'),
            {
                chunkName: () => '@msdyn365-commerce-modules-core-components-dist-lib-modules-default-external-script-default-external-script',
                ignoreBabelRename: true
            }
        ),
        $type: 'scriptModule',
        dataActions: [],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/core-components/dist/lib/modules/default-external-script/default-external-script.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'default-external-script',
        packageName: 'core-components',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/core-components/dist/lib/modules/default-external-script'
    });
            

    isNotRegistered('default-inline-script') && (binding.modules['default-inline-script'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/core-components/dist/lib/modules/default-inline-script/default-inline-script'),
            {
                chunkName: () => '@msdyn365-commerce-modules-core-components-dist-lib-modules-default-inline-script-default-inline-script',
                ignoreBabelRename: true
            }
        ),
        $type: 'scriptModule',
        dataActions: [],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/core-components/dist/lib/modules/default-inline-script/default-inline-script.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'default-inline-script',
        packageName: 'core-components',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/core-components/dist/lib/modules/default-inline-script'
    });
            

    isNotRegistered('default-metatags') && (binding.modules['default-metatags'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/core-components/dist/lib/modules/default-metatags/default-metatags'),
            {
                chunkName: () => '@msdyn365-commerce-modules-core-components-dist-lib-modules-default-metatags-default-metatags',
                ignoreBabelRename: true
            }
        ),
        $type: 'htmlHeadTagsModule',
        dataActions: [],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/core-components/dist/lib/modules/default-metatags/default-metatags.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'default-metatags',
        packageName: 'core-components',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/core-components/dist/lib/modules/default-metatags'
    });
            

    isNotRegistered('default-page') && (binding.modules['default-page'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/core-components/dist/lib/modules/default-page/default-page'),
            {
                chunkName: () => '@msdyn365-commerce-modules-core-components-dist-lib-modules-default-page-default-page',
                ignoreBabelRename: true
            }
        ),
        $type: 'pageModule',
        dataActions: [],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/core-components/dist/lib/modules/default-page/default-page.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'default-page',
        packageName: 'core-components',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/core-components/dist/lib/modules/default-page'
    });
            

    isNotRegistered('default-page-summary') && (binding.modules['default-page-summary'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/page-summary/dist/lib/modules/default-page-summary/default-page-summary'),
            {
                chunkName: () => '@msdyn365-commerce-modules-page-summary-dist-lib-modules-default-page-summary-default-page-summary',
                ignoreBabelRename: true
            }
        ),
        $type: 'htmlHeadTagsModule',
        dataActions: [{name:'pageSummary',  path:'@msdyn365-commerce-modules/page-summary/dist/lib/modules/default-page-summary/default-page-summary.action', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/page-summary/dist/lib/modules/default-page-summary/default-page-summary.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'default-page-summary',
        packageName: 'page-summary',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/page-summary/dist/lib/modules/default-page-summary'
    });
            

    isNotRegistered('fabrikam') && (binding.modules['fabrikam'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/fabrikam'),
            {
                chunkName: () => '@msdyn365-commerce-modules-fabrikam-design-kit-dist-lib-modules-fabrikam-fabrikam',
                ignoreBabelRename: true
            }
        ),
        $type: 'themeModule',
        dataActions: [],
        definitionExtensions: ['buybox','content-block','media-gallery','navigation-menu','promo-banner','text-block'],
        definitionPath: 'node_modules/@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/fabrikam.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'fabrikam',
        packageName: 'fabrikam-design-kit',
        
        parentDefinitionPath: '',
        
        themeSettings: 'fabrikam.theme.settings.json',
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam'
    });
            

    isNotRegistered('footer-category') && (binding.modules['footer-category'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/footer/dist/lib/modules/footer-category/footer-category'),
            {
                chunkName: () => '@msdyn365-commerce-modules-footer-dist-lib-modules-footer-category-footer-category',
                ignoreBabelRename: true
            }
        ),
        $type: 'containerModule',
        dataActions: [],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/footer/dist/lib/modules/footer-category/footer-category.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'footer-category',
        packageName: 'footer',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/footer/dist/lib/modules/footer-category'
    });
            

    isNotRegistered('footer-item') && (binding.modules['footer-item'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/footer/dist/lib/modules/footer-item/footer-item'),
            {
                chunkName: () => '@msdyn365-commerce-modules-footer-dist-lib-modules-footer-item-footer-item',
                ignoreBabelRename: true
            }
        ),
        $type: 'moduleDefinition',
        dataActions: [],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/footer/dist/lib/modules/footer-item/footer-item.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'footer-item',
        packageName: 'footer',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/footer/dist/lib/modules/footer-item'
    });
            

    isNotRegistered('gift-card-balance-check') && (binding.modules['gift-card-balance-check'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/checkout/dist/lib/modules/gift-card-balance-check/gift-card-balance-check'),
            {
                chunkName: () => '@msdyn365-commerce-modules-checkout-dist-lib-modules-gift-card-balance-check-gift-card-balance-check',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/checkout/dist/lib/modules/gift-card-balance-check/gift-card-balance-check.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'gift-card-balance-check',
        packageName: 'checkout',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/checkout/dist/lib/modules/gift-card-balance-check'
    });
            

    isNotRegistered('header') && (binding.modules['header'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/header/dist/lib/modules/header/header'),
            {
                chunkName: () => '@msdyn365-commerce-modules-header-dist-lib-modules-header-header',
                ignoreBabelRename: true
            }
        ),
        $type: 'containerModule',
        dataActions: [{name:'accountInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/get-cart-state-data-action', runOn: 1},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 1}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/header/dist/lib/modules/header/header.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'header',
        packageName: 'header',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/header/dist/lib/modules/header'
    });
            

    isNotRegistered('iframe') && (binding.modules['iframe'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/iframe/dist/lib/modules/iframe/iframe'),
            {
                chunkName: () => '@msdyn365-commerce-modules-iframe-dist-lib-modules-iframe-iframe',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/iframe/dist/lib/modules/iframe/iframe.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'iframe',
        packageName: 'iframe',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/iframe/dist/lib/modules/iframe'
    });
            

    isNotRegistered('image-list') && (binding.modules['image-list'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/image-list/dist/lib/modules/image-list/image-list'),
            {
                chunkName: () => '@msdyn365-commerce-modules-image-list-dist-lib-modules-image-list-image-list',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/image-list/dist/lib/modules/image-list/image-list.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'image-list',
        packageName: 'image-list',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/image-list/dist/lib/modules/image-list'
    });
            

    isNotRegistered('interactive-feature-collection') && (binding.modules['interactive-feature-collection'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/interactive-feature-collection/dist/lib/modules/interactive-feature-collection/interactive-feature-collection'),
            {
                chunkName: () => '@msdyn365-commerce-modules-interactive-feature-collection-dist-lib-modules-interactive-feature-collection-interactive-feature-collection',
                ignoreBabelRename: true
            }
        ),
        $type: 'containerModule',
        dataActions: [],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/interactive-feature-collection/dist/lib/modules/interactive-feature-collection/interactive-feature-collection.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'interactive-feature-collection',
        packageName: 'interactive-feature-collection',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/interactive-feature-collection/dist/lib/modules/interactive-feature-collection'
    });
            

    isNotRegistered('interactive-feature-item') && (binding.modules['interactive-feature-item'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/interactive-feature-collection/dist/lib/modules/interactive-feature-item/interactive-feature-item'),
            {
                chunkName: () => '@msdyn365-commerce-modules-interactive-feature-collection-dist-lib-modules-interactive-feature-item-interactive-feature-item',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/interactive-feature-collection/dist/lib/modules/interactive-feature-item/interactive-feature-item.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'interactive-feature-item',
        packageName: 'interactive-feature-collection',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/interactive-feature-collection/dist/lib/modules/interactive-feature-item'
    });
            

    isNotRegistered('invoice-details') && (binding.modules['invoice-details'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/invoice-details/dist/lib/modules/invoice-details/invoice-details'),
            {
                chunkName: () => '@msdyn365-commerce-modules-invoice-details-dist-lib-modules-invoice-details-invoice-details',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'invoice',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/invoices/get-invoice', runOn: 0},{name:'invoiceDetails',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/invoices/get-invoice-details', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/invoice-details/dist/lib/modules/invoice-details/invoice-details.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'invoice-details',
        packageName: 'invoice-details',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/invoice-details/dist/lib/modules/invoice-details'
    });
            

    isNotRegistered('invoices-list') && (binding.modules['invoices-list'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/invoice/dist/lib/modules/invoices-list/invoices-list'),
            {
                chunkName: () => '@msdyn365-commerce-modules-invoice-dist-lib-modules-invoices-list-invoices-list',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'b2bUserInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-business-partner-user', runOn: 0},{name:'customer',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'customerBalance',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance', runOn: 0},{name:'invoices',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/invoices/get-invoices', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/invoice/dist/lib/modules/invoices-list/invoices-list.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'invoices-list',
        packageName: 'invoice',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/invoice/dist/lib/modules/invoices-list'
    });
            

    isNotRegistered('list-page-summary') && (binding.modules['list-page-summary'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/page-summary/dist/lib/modules/default-page-summary/default-page-summary'),
            {
                chunkName: () => '@msdyn365-commerce-modules-page-summary-dist-lib-modules-default-page-summary-default-page-summary',
                ignoreBabelRename: true
            }
        ),
        $type: 'htmlHeadTagsModule',
        dataActions: [{name:'pageSummary',  path:'@msdyn365-commerce-modules/page-summary/dist/lib/modules/list-page-summary/list-page-summary.action', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/page-summary/dist/lib/modules/list-page-summary/list-page-summary.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'list-page-summary',
        packageName: 'page-summary',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/page-summary/dist/lib/modules/list-page-summary'
    });
            

    isNotRegistered('loyalty-sign-up') && (binding.modules['loyalty-sign-up'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/loyalty-sign-up/loyalty-sign-up'),
            {
                chunkName: () => '@msdyn365-commerce-modules-account-management-dist-lib-modules-loyalty-sign-up-loyalty-sign-up',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'loyaltyCard',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/loyalty-sign-up/loyalty-sign-up.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'loyalty-sign-up',
        packageName: 'account-management',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/loyalty-sign-up'
    });
            

    isNotRegistered('loyalty-terms') && (binding.modules['loyalty-terms'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/loyalty-terms/loyalty-terms'),
            {
                chunkName: () => '@msdyn365-commerce-modules-account-management-dist-lib-modules-loyalty-terms-loyalty-terms',
                ignoreBabelRename: true
            }
        ),
        $type: 'containerModule',
        dataActions: [{name:'loyaltyCard',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card', runOn: 1}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/loyalty-terms/loyalty-terms.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'loyalty-terms',
        packageName: 'account-management',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/loyalty-terms'
    });
            

    isNotRegistered('map') && (binding.modules['map'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/map/dist/lib/modules/map/map'),
            {
                chunkName: () => '@msdyn365-commerce-modules-map-dist-lib-modules-map-map',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/map/dist/lib/modules/map/map.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'map',
        packageName: 'map',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/map/dist/lib/modules/map'
    });
            

    isNotRegistered('media-gallery') && (binding.modules['media-gallery'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/media-gallery/dist/lib/modules/media-gallery/media-gallery'),
            {
                chunkName: () => '@msdyn365-commerce-modules-media-gallery-dist-lib-modules-media-gallery-media-gallery',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'mediaLocations',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-media-locations-by-id', runOn: 0},{name:'mediaLocationsForSelectedVariant',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-media-locations-for-selected-variant', runOn: 0},{name:'product',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/media-gallery/dist/lib/modules/media-gallery/media-gallery.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'media-gallery',
        packageName: 'media-gallery',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/media-gallery/dist/lib/modules/media-gallery'
    });
            

    isNotRegistered('navigation-menu') && (binding.modules['navigation-menu'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/navigation-menu/dist/lib/modules/navigation-menu/navigation-menu'),
            {
                chunkName: () => '@msdyn365-commerce-modules-navigation-menu-dist-lib-modules-navigation-menu-navigation-menu',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'categories',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/navigation-menu/dist/lib/modules/navigation-menu/navigation-menu.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'navigation-menu',
        packageName: 'navigation-menu',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/navigation-menu/dist/lib/modules/navigation-menu'
    });
            

    isNotRegistered('notifications-list') && (binding.modules['notifications-list'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/notifications-lists/dist/lib/modules/notifications-list/notifications-list'),
            {
                chunkName: () => '@msdyn365-commerce-modules-notifications-lists-dist-lib-modules-notifications-list-notifications-list',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/notifications-lists/dist/lib/modules/notifications-list/notifications-list.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'notifications-list',
        packageName: 'notifications-lists',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/notifications-lists/dist/lib/modules/notifications-list'
    });
            

    isNotRegistered('order-confirmation') && (binding.modules['order-confirmation'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/order-management/dist/lib/modules/order-confirmation/order-confirmation'),
            {
                chunkName: () => '@msdyn365-commerce-modules-order-management-dist-lib-modules-order-confirmation-order-confirmation',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'loyaltyCard',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card', runOn: 1},{name:'orderHydration',  path:'@msdyn365-commerce-modules/order-management/dist/lib/actions/get-sales-order-confirmation-with-hydrations', runOn: 0},{name:'tenderTypes',  path:'@msdyn365-commerce-modules/order-management/dist/lib/actions/get-tender-types', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/order-management/dist/lib/modules/order-confirmation/order-confirmation.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'order-confirmation',
        packageName: 'order-management',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/order-management/dist/lib/modules/order-confirmation'
    });
            

    isNotRegistered('order-details') && (binding.modules['order-details'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/order-management/dist/lib/modules/order-details/order-details'),
            {
                chunkName: () => '@msdyn365-commerce-modules-order-management-dist-lib-modules-order-details-order-details',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'channels',  path:'@msdyn365-commerce-modules/order-management/dist/lib/actions/get-channels', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'loyaltyCard',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card', runOn: 1},{name:'orderHydration',  path:'@msdyn365-commerce-modules/order-management/dist/lib/actions/get-sales-order-with-hydrations', runOn: 0},{name:'orgUnitLocations',  path:'@msdyn365-commerce-modules/order-management/dist/lib/actions/get-org-unit-locations', runOn: 0},{name:'tenderTypes',  path:'@msdyn365-commerce-modules/order-management/dist/lib/actions/get-tender-types', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/order-management/dist/lib/modules/order-details/order-details.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'order-details',
        packageName: 'order-management',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/order-management/dist/lib/modules/order-details'
    });
            

    isNotRegistered('order-history') && (binding.modules['order-history'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/order-management/dist/lib/modules/order-history/order-history'),
            {
                chunkName: () => '@msdyn365-commerce-modules-order-management-dist-lib-modules-order-history-order-history',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'channels',  path:'@msdyn365-commerce-modules/order-management/dist/lib/actions/get-channels', runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'orgUnitLocations',  path:'@msdyn365-commerce-modules/order-management/dist/lib/actions/get-org-unit-locations', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/order-management/dist/lib/modules/order-history/order-history.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'order-history',
        packageName: 'order-management',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/order-management/dist/lib/modules/order-history'
    });
            

    isNotRegistered('order-lookup') && (binding.modules['order-lookup'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/order-management/dist/lib/modules/order-lookup/order-lookup'),
            {
                chunkName: () => '@msdyn365-commerce-modules-order-management-dist-lib-modules-order-lookup-order-lookup',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/order-management/dist/lib/modules/order-lookup/order-lookup.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'order-lookup',
        packageName: 'order-management',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/order-management/dist/lib/modules/order-lookup'
    });
            

    isNotRegistered('order-template') && (binding.modules['order-template'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/order-template/dist/lib/modules/order-template/order-template'),
            {
                chunkName: () => '@msdyn365-commerce-modules-order-template-dist-lib-modules-order-template-order-template',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'orderTemplate',  path:'@msdyn365-commerce-modules/order-template/dist/lib/modules/order-template/actions/get-order-template', runOn: 1}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/order-template/dist/lib/modules/order-template/order-template.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'order-template',
        packageName: 'order-template',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/order-template/dist/lib/modules/order-template'
    });
            

    isNotRegistered('order-template-list') && (binding.modules['order-template-list'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/order-template/dist/lib/modules/order-template-list/order-template-list'),
            {
                chunkName: () => '@msdyn365-commerce-modules-order-template-dist-lib-modules-order-template-list-order-template-list',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'orderTemplates',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/order-templates/get-order-templates-preview', runOn: 1}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/order-template/dist/lib/modules/order-template-list/order-template-list.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'order-template-list',
        packageName: 'order-template',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/order-template/dist/lib/modules/order-template-list'
    });
            

    isNotRegistered('organization-users-tile') && (binding.modules['organization-users-tile'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/organization-users-tile/organization-users-tile'),
            {
                chunkName: () => '@msdyn365-commerce-modules-account-management-dist-lib-modules-organization-users-tile-organization-users-tile',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'users',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-organization-users-count', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/organization-users-tile/organization-users-tile.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'organization-users-tile',
        packageName: 'account-management',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/organization-users-tile'
    });
            

    isNotRegistered('password-reset') && (binding.modules['password-reset'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/password-reset/password-reset'),
            {
                chunkName: () => '@msdyn365-commerce-modules-account-management-dist-lib-modules-password-reset-password-reset',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/password-reset/password-reset.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'password-reset',
        packageName: 'account-management',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/password-reset'
    });
            

    isNotRegistered('password-reset-verification') && (binding.modules['password-reset-verification'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/password-reset-verification/password-reset-verification'),
            {
                chunkName: () => '@msdyn365-commerce-modules-account-management-dist-lib-modules-password-reset-verification-password-reset-verification',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/password-reset-verification/password-reset-verification.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'password-reset-verification',
        packageName: 'account-management',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/password-reset-verification'
    });
            

    isNotRegistered('place-holder-for-container-preview') && (binding.modules['place-holder-for-container-preview'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/core-components/dist/lib/modules/place-holder-for-container-preview/place-holder-for-container-preview'),
            {
                chunkName: () => '@msdyn365-commerce-modules-core-components-dist-lib-modules-place-holder-for-container-preview-place-holder-for-container-preview',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/core-components/dist/lib/modules/place-holder-for-container-preview/place-holder-for-container-preview.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'place-holder-for-container-preview',
        packageName: 'core-components',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/core-components/dist/lib/modules/place-holder-for-container-preview'
    });
            

    isNotRegistered('product-collection') && (binding.modules['product-collection'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/product-collection/dist/lib/modules/product-collection/product-collection'),
            {
                chunkName: () => '@msdyn365-commerce-modules-product-collection-dist-lib-modules-product-collection-product-collection',
                ignoreBabelRename: true
            }
        ),
        $type: 'containerModule',
        dataActions: [{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/product-collection/dist/lib/modules/product-collection/product-collection.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'product-collection',
        packageName: 'product-collection',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/product-collection/dist/lib/modules/product-collection'
    });
            

    isNotRegistered('product-page-summary') && (binding.modules['product-page-summary'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/page-summary/dist/lib/modules/product-page-summary/product-page-summary'),
            {
                chunkName: () => '@msdyn365-commerce-modules-page-summary-dist-lib-modules-product-page-summary-product-page-summary',
                ignoreBabelRename: true
            }
        ),
        $type: 'htmlHeadTagsModule',
        dataActions: [{name:'productPageSummary',  path:'@msdyn365-commerce-modules/page-summary/dist/lib/modules/product-page-summary/product-page-summary.action', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/page-summary/dist/lib/modules/product-page-summary/product-page-summary.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'product-page-summary',
        packageName: 'page-summary',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/page-summary/dist/lib/modules/product-page-summary'
    });
            

    isNotRegistered('product-specification') && (binding.modules['product-specification'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/product-specification/dist/lib/modules/product-specification/product-specification'),
            {
                chunkName: () => '@msdyn365-commerce-modules-product-specification-dist-lib-modules-product-specification-product-specification',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'product',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 0},{name:'productSpecificationData',  path:'@msdyn365-commerce-modules/product-specification/dist/lib/dataActions/get-attributes-for-selected-variant', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/product-specification/dist/lib/modules/product-specification/product-specification.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'product-specification',
        packageName: 'product-specification',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/product-specification/dist/lib/modules/product-specification'
    });
            

    isNotRegistered('promo-banner') && (binding.modules['promo-banner'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/promo-banner/dist/lib/modules/promo-banner/promo-banner'),
            {
                chunkName: () => '@msdyn365-commerce-modules-promo-banner-dist-lib-modules-promo-banner-promo-banner',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/promo-banner/dist/lib/modules/promo-banner/promo-banner.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'promo-banner',
        packageName: 'promo-banner',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/promo-banner/dist/lib/modules/promo-banner'
    });
            

    isNotRegistered('quick-order') && (binding.modules['quick-order'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/quick-order/dist/lib/modules/quick-order/quick-order'),
            {
                chunkName: () => '@msdyn365-commerce-modules-quick-order-dist-lib-modules-quick-order-quick-order',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 1},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/quick-order/dist/lib/modules/quick-order/quick-order.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'quick-order',
        packageName: 'quick-order',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/quick-order/dist/lib/modules/quick-order'
    });
            

    isNotRegistered('quick-order-grid') && (binding.modules['quick-order-grid'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/quick-order-grid/dist/lib/modules/quick-order-grid/quick-order-grid'),
            {
                chunkName: () => '@msdyn365-commerce-modules-quick-order-grid-dist-lib-modules-quick-order-grid-quick-order-grid',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 1},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'quickOrderTemplate',  path:'@msdyn365-commerce-modules/quick-order-grid/dist/lib/modules/quick-order-grid/actions/get-product-list', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/quick-order-grid/dist/lib/modules/quick-order-grid/quick-order-grid.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'quick-order-grid',
        packageName: 'quick-order-grid',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/quick-order-grid/dist/lib/modules/quick-order-grid'
    });
            

    isNotRegistered('quickview') && (binding.modules['quickview'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/buybox/dist/lib/modules/quickview/quickview'),
            {
                chunkName: () => '@msdyn365-commerce-modules-buybox-dist-lib-modules-quickview-quickview',
                ignoreBabelRename: true
            }
        ),
        $type: 'containerModule',
        dataActions: [{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'wishlists',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/buybox/dist/lib/modules/quickview/quickview.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'quickview',
        packageName: 'buybox',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/buybox/dist/lib/modules/quickview'
    });
            

    isNotRegistered('ratings-histogram') && (binding.modules['ratings-histogram'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/ratings-reviews/dist/lib/modules/ratings-histogram/ratings-histogram'),
            {
                chunkName: () => '@msdyn365-commerce-modules-ratings-reviews-dist-lib-modules-ratings-histogram-ratings-histogram',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'ratingsReviewsState',  path:'@msdyn365-commerce-modules/ratings-reviews/dist/lib/actions/ratings-reviews-state-data-action', runOn: 1},{name:'ratingsSummary',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-ratings-summary', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/ratings-reviews/dist/lib/modules/ratings-histogram/ratings-histogram.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'ratings-histogram',
        packageName: 'ratings-reviews',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/ratings-reviews/dist/lib/modules/ratings-histogram'
    });
            

    isNotRegistered('reviews-list') && (binding.modules['reviews-list'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/ratings-reviews/dist/lib/modules/reviews-list/reviews-list'),
            {
                chunkName: () => '@msdyn365-commerce-modules-ratings-reviews-dist-lib-modules-reviews-list-reviews-list',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'product',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 0},{name:'ratingsReviewsState',  path:'@msdyn365-commerce-modules/ratings-reviews/dist/lib/actions/ratings-reviews-state-data-action', runOn: 1},{name:'ratingsSummary',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-ratings-summary', runOn: 0},{name:'reviewsList',  path:'@msdyn365-commerce-modules/ratings-reviews/dist/lib/actions/get-product-reviews', runOn: 0},{name:'userReview',  path:'@msdyn365-commerce-modules/ratings-reviews/dist/lib/actions/get-user-review', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/ratings-reviews/dist/lib/modules/reviews-list/reviews-list.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'reviews-list',
        packageName: 'ratings-reviews',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/ratings-reviews/dist/lib/modules/reviews-list'
    });
            

    isNotRegistered('script-injector') && (binding.modules['script-injector'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/core-components/dist/lib/modules/script-injector/script-injector'),
            {
                chunkName: () => '@msdyn365-commerce-modules-core-components-dist-lib-modules-script-injector-script-injector',
                ignoreBabelRename: true
            }
        ),
        $type: 'scriptModule',
        dataActions: [],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/core-components/dist/lib/modules/script-injector/script-injector.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'script-injector',
        packageName: 'core-components',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/core-components/dist/lib/modules/script-injector'
    });
            

    isNotRegistered('search') && (binding.modules['search'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/search/dist/lib/modules/search/search'),
            {
                chunkName: () => '@msdyn365-commerce-modules-search-dist-lib-modules-search-search',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'searchState',  path:'@msdyn365-commerce-modules/search-utilities/dist/lib/search-state-data-action', runOn: 1}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/search/dist/lib/modules/search/search.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'search',
        packageName: 'search',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/search/dist/lib/modules/search'
    });
            

    isNotRegistered('search-result-container') && (binding.modules['search-result-container'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/search-result-container/dist/lib/modules/search-result-container/search-result-container'),
            {
                chunkName: () => '@msdyn365-commerce-modules-search-result-container-dist-lib-modules-search-result-container-search-result-container',
                ignoreBabelRename: true
            }
        ),
        $type: 'containerModule',
        dataActions: [{name:'category',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category', runOn: 0},{name:'categoryHierarchy',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category-hierarchy', runOn: 0},{name:'featureProduct',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'listPageState',  path:'@msdyn365-commerce-modules/search-result-container/dist/lib/modules/search-result-container/list-page-state', runOn: 0},{name:'products',  path:'@msdyn365-commerce-modules/search-result-container/dist/lib/modules/search-result-container/actions/get-full-products-by-collection', runOn: 0},{name:'refiners',  path:'@msdyn365-commerce-modules/search-result-container/dist/lib/modules/search-result-container/actions/get-refiners-for-collection', runOn: 0},{name:'searchConfiguration',  path:'@msdyn365-commerce-modules/search-result-container/dist/lib/modules/search-result-container/actions/get-mapped-search-configuration', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/search-result-container/dist/lib/modules/search-result-container/search-result-container.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'search-result-container',
        packageName: 'search-result-container',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/search-result-container/dist/lib/modules/search-result-container'
    });
            

    isNotRegistered('sign-in') && (binding.modules['sign-in'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/sign-in/sign-in'),
            {
                chunkName: () => '@msdyn365-commerce-modules-account-management-dist-lib-modules-sign-in-sign-in',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/sign-in/sign-in.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'sign-in',
        packageName: 'account-management',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/sign-in'
    });
            

    isNotRegistered('sign-up') && (binding.modules['sign-up'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/sign-up/sign-up'),
            {
                chunkName: () => '@msdyn365-commerce-modules-account-management-dist-lib-modules-sign-up-sign-up',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/sign-up/sign-up.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'sign-up',
        packageName: 'account-management',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/account-management/dist/lib/modules/sign-up'
    });
            

    isNotRegistered('site-picker') && (binding.modules['site-picker'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/site-picker/dist/lib/modules/site-picker/site-picker'),
            {
                chunkName: () => '@msdyn365-commerce-modules-site-picker-dist-lib-modules-site-picker-site-picker',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/site-picker/dist/lib/modules/site-picker/site-picker.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'site-picker',
        packageName: 'site-picker',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/site-picker/dist/lib/modules/site-picker'
    });
            

    isNotRegistered('social-share') && (binding.modules['social-share'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/social-share/dist/lib/modules/social-share/social-share'),
            {
                chunkName: () => '@msdyn365-commerce-modules-social-share-dist-lib-modules-social-share-social-share',
                ignoreBabelRename: true
            }
        ),
        $type: 'moduleDefinition',
        dataActions: [],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/social-share/dist/lib/modules/social-share/social-share.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'social-share',
        packageName: 'social-share',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/social-share/dist/lib/modules/social-share'
    });
            

    isNotRegistered('social-share-item') && (binding.modules['social-share-item'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/social-share/dist/lib/modules/social-share-item/social-share-item'),
            {
                chunkName: () => '@msdyn365-commerce-modules-social-share-dist-lib-modules-social-share-item-social-share-item',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/social-share/dist/lib/modules/social-share-item/social-share-item.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'social-share-item',
        packageName: 'social-share',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/social-share/dist/lib/modules/social-share-item'
    });
            

    isNotRegistered('spacer') && (binding.modules['spacer'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/spacer/dist/lib/modules/spacer/spacer'),
            {
                chunkName: () => '@msdyn365-commerce-modules-spacer-dist-lib-modules-spacer-spacer',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/spacer/dist/lib/modules/spacer/spacer.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'spacer',
        packageName: 'spacer',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/spacer/dist/lib/modules/spacer'
    });
            

    isNotRegistered('starter') && (binding.modules['starter'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/starter-theme-pack/dist/lib/modules/starter/starter'),
            {
                chunkName: () => '@msdyn365-commerce-modules-starter-theme-pack-dist-lib-modules-starter-starter',
                ignoreBabelRename: true
            }
        ),
        $type: 'themeModule',
        dataActions: [],
        definitionExtensions: ['content-block','promo-banner','text-block'],
        definitionPath: 'node_modules/@msdyn365-commerce-modules/starter-theme-pack/dist/lib/modules/starter/starter.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'starter',
        packageName: 'starter-theme-pack',
        
        parentDefinitionPath: '',
        
        themeSettings: 'starter.theme.settings.json',
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/starter-theme-pack/dist/lib/modules/starter'
    });
            

    isNotRegistered('store-selector') && (binding.modules['store-selector'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/store-selector/dist/lib/modules/store-selector/store-selector'),
            {
                chunkName: () => '@msdyn365-commerce-modules-store-selector-dist-lib-modules-store-selector-store-selector',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'availabilitiesWithHours',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-full-available-inventory-nearby', runOn: 1},{name:'storeLocations',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-store-location-information', runOn: 1},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/store-selector/dist/lib/modules/store-selector/store-selector.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'store-selector',
        packageName: 'store-selector',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/store-selector/dist/lib/modules/store-selector'
    });
            

    isNotRegistered('subscribe') && (binding.modules['subscribe'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/subscribe/dist/lib/modules/subscribe/subscribe'),
            {
                chunkName: () => '@msdyn365-commerce-modules-subscribe-dist-lib-modules-subscribe-subscribe',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/subscribe/dist/lib/modules/subscribe/subscribe.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'subscribe',
        packageName: 'subscribe',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/subscribe/dist/lib/modules/subscribe'
    });
            

    isNotRegistered('tab') && (binding.modules['tab'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/tab/dist/lib/modules/tab/tab'),
            {
                chunkName: () => '@msdyn365-commerce-modules-tab-dist-lib-modules-tab-tab',
                ignoreBabelRename: true
            }
        ),
        $type: 'moduleDefinition',
        dataActions: [{name:'activeTabState',  path:'@msdyn365-commerce-modules/tab/dist/lib/data-actions/tab-state-data-action', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/tab/dist/lib/modules/tab/tab.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'tab',
        packageName: 'tab',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/tab/dist/lib/modules/tab'
    });
            

    isNotRegistered('tab-item') && (binding.modules['tab-item'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/tab/dist/lib/modules/tab-item/tab-item'),
            {
                chunkName: () => '@msdyn365-commerce-modules-tab-dist-lib-modules-tab-item-tab-item',
                ignoreBabelRename: true
            }
        ),
        $type: 'moduleDefinition',
        dataActions: [{name:'activeTabState',  path:'@msdyn365-commerce-modules/tab/dist/lib/data-actions/tab-state-data-action', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/tab/dist/lib/modules/tab-item/tab-item.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'tab-item',
        packageName: 'tab',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/tab/dist/lib/modules/tab-item'
    });
            

    isNotRegistered('text-block') && (binding.modules['text-block'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/text-block/dist/lib/modules/text-block/text-block'),
            {
                chunkName: () => '@msdyn365-commerce-modules-text-block-dist-lib-modules-text-block-text-block',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/text-block/dist/lib/modules/text-block/text-block.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'text-block',
        packageName: 'text-block',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/text-block/dist/lib/modules/text-block'
    });
            

    isNotRegistered('tile-list') && (binding.modules['tile-list'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/tile-list/dist/lib/modules/tile-list/tile-list'),
            {
                chunkName: () => '@msdyn365-commerce-modules-tile-list-dist-lib-modules-tile-list-tile-list',
                ignoreBabelRename: true
            }
        ),
        $type: 'containerModule',
        dataActions: [],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/tile-list/dist/lib/modules/tile-list/tile-list.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'tile-list',
        packageName: 'tile-list',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/tile-list/dist/lib/modules/tile-list'
    });
            

    isNotRegistered('tile-list-item') && (binding.modules['tile-list-item'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/tile-list/dist/lib/modules/tile-list-item/tile-list-item'),
            {
                chunkName: () => '@msdyn365-commerce-modules-tile-list-dist-lib-modules-tile-list-item-tile-list-item',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/tile-list/dist/lib/modules/tile-list-item/tile-list-item.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'tile-list-item',
        packageName: 'tile-list',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/tile-list/dist/lib/modules/tile-list-item'
    });
            

    isNotRegistered('video-player') && (binding.modules['video-player'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/video-player/dist/lib/modules/video-player/video-player'),
            {
                chunkName: () => '@msdyn365-commerce-modules-video-player-dist-lib-modules-video-player-video-player',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/video-player/dist/lib/modules/video-player/video-player.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'video-player',
        packageName: 'video-player',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/video-player/dist/lib/modules/video-player'
    });
            

    isNotRegistered('wishlist-items') && (binding.modules['wishlist-items'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/wishlist/dist/lib/modules/wishlist-items/wishlist-items'),
            {
                chunkName: () => '@msdyn365-commerce-modules-wishlist-dist-lib-modules-wishlist-items-wishlist-items',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'productAvailability',  path:'@msdyn365-commerce-modules/wishlist/dist/lib/modules/wishlist-items/actions/get-product-availabilities-wishlist-items', runOn: 1},{name:'products',  path:'@msdyn365-commerce-modules/wishlist/dist/lib/modules/wishlist-items/actions/get-items-in-wishlists', runOn: 1},{name:'wishlists',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id', runOn: 1}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/wishlist/dist/lib/modules/wishlist-items/wishlist-items.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'wishlist-items',
        packageName: 'wishlist',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/wishlist/dist/lib/modules/wishlist-items'
    });
            

    isNotRegistered('write-review') && (binding.modules['write-review'] = {
        component: universal(
            () =>
                import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                '@msdyn365-commerce-modules/ratings-reviews/dist/lib/modules/write-review/write-review'),
            {
                chunkName: () => '@msdyn365-commerce-modules-ratings-reviews-dist-lib-modules-write-review-write-review',
                ignoreBabelRename: true
            }
        ),
        $type: 'contentModule',
        dataActions: [{name:'product',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 0},{name:'userReview',  path:'@msdyn365-commerce-modules/ratings-reviews/dist/lib/actions/get-user-review', runOn: 0}],
        
        definitionPath: 'node_modules/@msdyn365-commerce-modules/ratings-reviews/dist/lib/modules/write-review/write-review.definition.json',
        isNodeModule: true,
        moduleNamespace: '@msdyn365-commerce-modules',
        name: 'write-review',
        packageName: 'ratings-reviews',
        
        parentDefinitionPath: '',
        
        
        moduleDirectory: 'node_modules/@msdyn365-commerce-modules/ratings-reviews/dist/lib/modules/write-review'
    });
            

        {
            
            const actionPath = '@msdyn365-commerce-modules/core-components/dist/lib/actions/addToCart-telemetry.action';
            binding.dataActions[actionPath] = require('@msdyn365-commerce-modules/core-components/dist/lib/actions/addToCart-telemetry.action');
            if (binding.dataActions[actionPath] &&
                binding.dataActions[actionPath].default &&
                binding.dataActions[actionPath].default.prototype &&
                binding.dataActions[actionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
            }
        
        }

        {
            
            const actionPath = '@msdyn365-commerce-modules/core-components/dist/lib/actions/copyCart-checkOut-telemetry.action';
            binding.dataActions[actionPath] = require('@msdyn365-commerce-modules/core-components/dist/lib/actions/copyCart-checkOut-telemetry.action');
            if (binding.dataActions[actionPath] &&
                binding.dataActions[actionPath].default &&
                binding.dataActions[actionPath].default.prototype &&
                binding.dataActions[actionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
            }
        
        }

        {
            
            const actionPath = '@msdyn365-commerce-modules/core-components/dist/lib/actions/getById-product-telemetry.action';
            binding.dataActions[actionPath] = require('@msdyn365-commerce-modules/core-components/dist/lib/actions/getById-product-telemetry.action');
            if (binding.dataActions[actionPath] &&
                binding.dataActions[actionPath].default &&
                binding.dataActions[actionPath].default.prototype &&
                binding.dataActions[actionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
            }
        
        }

        {
            
            const actionPath = '@msdyn365-commerce-modules/core-components/dist/lib/actions/getByIds-product-telemetry.action';
            binding.dataActions[actionPath] = require('@msdyn365-commerce-modules/core-components/dist/lib/actions/getByIds-product-telemetry.action');
            if (binding.dataActions[actionPath] &&
                binding.dataActions[actionPath].default &&
                binding.dataActions[actionPath].default.prototype &&
                binding.dataActions[actionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
            }
        
        }

        {
            
            const actionPath = '@msdyn365-commerce-modules/core-components/dist/lib/actions/getVariantsByDimensionValues-telemetry.action';
            binding.dataActions[actionPath] = require('@msdyn365-commerce-modules/core-components/dist/lib/actions/getVariantsByDimensionValues-telemetry.action');
            if (binding.dataActions[actionPath] &&
                binding.dataActions[actionPath].default &&
                binding.dataActions[actionPath].default.prototype &&
                binding.dataActions[actionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
            }
        
        }

        {
            
            const actionPath = '@msdyn365-commerce-modules/core-components/dist/lib/actions/purchase-telemetry.action';
            binding.dataActions[actionPath] = require('@msdyn365-commerce-modules/core-components/dist/lib/actions/purchase-telemetry.action');
            if (binding.dataActions[actionPath] &&
                binding.dataActions[actionPath].default &&
                binding.dataActions[actionPath].default.prototype &&
                binding.dataActions[actionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
            }
        
        }

        {
            
            const actionPath = '@msdyn365-commerce-modules/core-components/dist/lib/actions/readCart-telemetry.action';
            binding.dataActions[actionPath] = require('@msdyn365-commerce-modules/core-components/dist/lib/actions/readCart-telemetry.action');
            if (binding.dataActions[actionPath] &&
                binding.dataActions[actionPath].default &&
                binding.dataActions[actionPath].default.prototype &&
                binding.dataActions[actionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
            }
        
        }

        {
            
            const actionPath = '@msdyn365-commerce-modules/core-components/dist/lib/actions/removeFromCart-telemetry.action';
            binding.dataActions[actionPath] = require('@msdyn365-commerce-modules/core-components/dist/lib/actions/removeFromCart-telemetry.action');
            if (binding.dataActions[actionPath] &&
                binding.dataActions[actionPath].default &&
                binding.dataActions[actionPath].default.prototype &&
                binding.dataActions[actionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
            }
        
        }

        {
            
            const actionPath = '@msdyn365-commerce-modules/core-components/dist/lib/actions/updateCart-telemetry.action';
            binding.dataActions[actionPath] = require('@msdyn365-commerce-modules/core-components/dist/lib/actions/updateCart-telemetry.action');
            if (binding.dataActions[actionPath] &&
                binding.dataActions[actionPath].default &&
                binding.dataActions[actionPath].default.prototype &&
                binding.dataActions[actionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
            }
        
        }

        {
            
            const actionPath = '@msdyn365-commerce-modules/page-summary/dist/lib/modules/category-page-summary/category-page-summary.action';
            binding.dataActions[actionPath] = require('@msdyn365-commerce-modules/page-summary/dist/lib/modules/category-page-summary/category-page-summary.action');
            if (binding.dataActions[actionPath] &&
                binding.dataActions[actionPath].default &&
                binding.dataActions[actionPath].default.prototype &&
                binding.dataActions[actionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
            }
        
        }

        {
            
            const actionPath = '@msdyn365-commerce-modules/page-summary/dist/lib/modules/default-page-summary/default-page-summary.action';
            binding.dataActions[actionPath] = require('@msdyn365-commerce-modules/page-summary/dist/lib/modules/default-page-summary/default-page-summary.action');
            if (binding.dataActions[actionPath] &&
                binding.dataActions[actionPath].default &&
                binding.dataActions[actionPath].default.prototype &&
                binding.dataActions[actionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
            }
        
        }

        {
            
            const actionPath = '@msdyn365-commerce-modules/page-summary/dist/lib/modules/list-page-summary/list-page-summary.action';
            binding.dataActions[actionPath] = require('@msdyn365-commerce-modules/page-summary/dist/lib/modules/list-page-summary/list-page-summary.action');
            if (binding.dataActions[actionPath] &&
                binding.dataActions[actionPath].default &&
                binding.dataActions[actionPath].default.prototype &&
                binding.dataActions[actionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
            }
        
        }

        {
            
            const actionPath = '@msdyn365-commerce-modules/page-summary/dist/lib/modules/product-page-summary/product-page-summary.action';
            binding.dataActions[actionPath] = require('@msdyn365-commerce-modules/page-summary/dist/lib/modules/product-page-summary/product-page-summary.action');
            if (binding.dataActions[actionPath] &&
                binding.dataActions[actionPath].default &&
                binding.dataActions[actionPath].default.prototype &&
                binding.dataActions[actionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
            }
        
        }

        if (isNotRegistered('accordion')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/accordion/dist/lib/data-actions/accordion-state-data-action';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/accordion/dist/lib/data-actions/accordion-state-data-action');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('accordion-item')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/accordion/dist/lib/data-actions/accordion-state-data-action';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/accordion/dist/lib/data-actions/accordion-state-data-action');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('account-address-tile')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-address';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-address');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('account-address-tile')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('account-customer-balance')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-business-partner-user';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-business-partner-user');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('account-customer-balance')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('account-customer-balance')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('account-customer-balance-tile')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('account-customer-balance-tile')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('account-invoice-tile')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('account-invoice-tile')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/invoices/get-invoices';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/invoices/get-invoices');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('account-loyalty')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('account-loyalty-tile')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('account-management-address')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('account-management-address')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('account-management-address')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('account-management-address')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-address';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-address');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('account-order-templates-tile')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('account-order-templates-tile')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('account-order-templates-tile')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/order-templates/get-order-templates';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/order-templates/get-order-templates');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('account-profile')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-attribute-definitions';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-attribute-definitions');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('account-profile')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('account-welcome-tile')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('account-wishlist-tile')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('active-image')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/active-image/dist/lib/modules/actions/get-active-image-products';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/active-image/dist/lib/modules/actions/get-active-image-products');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('b2b-requests-status')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-business-partner-operation-requests';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-business-partner-operation-requests');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('b2b-requests-status')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-business-partner-user';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-business-partner-user');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('b2b-requests-status')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('b2b-requests-tile')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('breadcrumb')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-category-paths';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-category-paths');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('breadcrumb')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category-hierarchy';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category-hierarchy');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('breadcrumb')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('business-account-address')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('business-account-address')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('business-account-address')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('business-account-address')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-address';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-address');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('business-organization-list')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('business-organization-list')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-organization-users';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-organization-users');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('buybox')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('buybox')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('buybox')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('buybox')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-selected-variant';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-selected-variant');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('buybox')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-dimensions-for-selected-variant';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-dimensions-for-selected-variant');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('buybox')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('buybox')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-price-for-selected-variant';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-price-for-selected-variant');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('buybox')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-product-availabilities-for-selected-variant';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-product-availabilities-for-selected-variant');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('buybox')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-ratings-summary';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-ratings-summary');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('buybox')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('buybox')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('buybox')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/order-templates/get-order-templates-preview';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/order-templates/get-order-templates-preview');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('buybox')) {
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('cart')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('cart')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-availabilities-cartlines';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-availabilities-cartlines');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('cart')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('cart')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('cart')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('cart')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('cart')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-items-in-wishlist';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-items-in-wishlist');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('cart')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-products-in-active-cart';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-products-in-active-cart');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('cart')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('cart')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/order-templates/get-order-templates-preview';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/order-templates/get-order-templates-preview');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('cart')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('cart')) {
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('cart-icon')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('cart-icon')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('cart-icon')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('cart-icon')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('cart-icon')) {
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/get-cart-state-data-action';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce/global-state/dist/lib/data-actions/get-cart-state-data-action');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('category-page-summary')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/page-summary/dist/lib/modules/category-page-summary/category-page-summary.action';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/page-summary/dist/lib/modules/category-page-summary/category-page-summary.action');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout/actions/get-products-in-active-checkout-cart';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout/actions/get-products-in-active-checkout-cart');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout')) {
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout-billing-address')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout-billing-address')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout-billing-address')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout-billing-address')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout-billing-address')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout-billing-address')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout-billing-address')) {
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout-customer-account-payment')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout-customer-account-payment')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout-customer-account-payment')) {
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout-delivery-options')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout-delivery-options')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout-delivery-options')) {
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout-gift-card')) {
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout-guest-profile')) {
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout-guest-profile')) {
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout-loyalty')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout-loyalty')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-transaction-estimation';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-transaction-estimation');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout-loyalty')) {
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout-order-confirmation')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/order-management/dist/lib/actions/get-tender-types';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/order-management/dist/lib/actions/get-tender-types');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout-order-confirmation')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout-order-confirmation')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout-order-confirmation')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout-order-confirmation')) {
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout-payment-instrument')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-payment-instrument/actions/get-card-payment-accept-point';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-payment-instrument/actions/get-card-payment-accept-point');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout-payment-instrument')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout-payment-instrument')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout-payment-instrument')) {
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout-pickup')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout-pickup')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout-pickup')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout-pickup')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout-pickup')) {
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout-section-container')) {
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout-shipping-address')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout-shipping-address')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout-shipping-address')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout-shipping-address')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout-shipping-address')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-address';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-address');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout-shipping-address')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout-shipping-address')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout-shipping-address')) {
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('checkout-terms-and-conditions')) {
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('default-page-summary')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/page-summary/dist/lib/modules/default-page-summary/default-page-summary.action';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/page-summary/dist/lib/modules/default-page-summary/default-page-summary.action');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('header')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('header')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('header')) {
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/get-cart-state-data-action';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce/global-state/dist/lib/data-actions/get-cart-state-data-action');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('invoice-details')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/invoices/get-invoice';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/invoices/get-invoice');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('invoice-details')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/invoices/get-invoice-details';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/invoices/get-invoice-details');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('invoices-list')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-business-partner-user';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-business-partner-user');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('invoices-list')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('invoices-list')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('invoices-list')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/invoices/get-invoices';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/invoices/get-invoices');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('list-page-summary')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/page-summary/dist/lib/modules/list-page-summary/list-page-summary.action';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/page-summary/dist/lib/modules/list-page-summary/list-page-summary.action');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('loyalty-sign-up')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('loyalty-terms')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('map')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('media-gallery')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-media-locations-by-id';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-media-locations-by-id');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('media-gallery')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-media-locations-for-selected-variant';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-media-locations-for-selected-variant');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('media-gallery')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('navigation-menu')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('order-confirmation')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/order-management/dist/lib/actions/get-sales-order-confirmation-with-hydrations';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/order-management/dist/lib/actions/get-sales-order-confirmation-with-hydrations');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('order-confirmation')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/order-management/dist/lib/actions/get-tender-types';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/order-management/dist/lib/actions/get-tender-types');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('order-confirmation')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('order-confirmation')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('order-confirmation')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('order-details')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/order-management/dist/lib/actions/get-channels';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/order-management/dist/lib/actions/get-channels');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('order-details')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/order-management/dist/lib/actions/get-org-unit-locations';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/order-management/dist/lib/actions/get-org-unit-locations');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('order-details')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/order-management/dist/lib/actions/get-sales-order-with-hydrations';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/order-management/dist/lib/actions/get-sales-order-with-hydrations');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('order-details')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/order-management/dist/lib/actions/get-tender-types';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/order-management/dist/lib/actions/get-tender-types');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('order-details')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('order-details')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('order-details')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('order-history')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/order-management/dist/lib/actions/get-channels';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/order-management/dist/lib/actions/get-channels');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('order-history')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/order-management/dist/lib/actions/get-org-unit-locations';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/order-management/dist/lib/actions/get-org-unit-locations');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('order-history')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('order-history')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('order-history')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('order-template')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/order-template/dist/lib/modules/order-template/actions/get-order-template';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/order-template/dist/lib/modules/order-template/actions/get-order-template');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('order-template')) {
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('order-template-list')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/order-templates/get-order-templates-preview';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/order-templates/get-order-templates-preview');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('organization-users-tile')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-organization-users-count';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-organization-users-count');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('product-collection')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('product-page-summary')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/page-summary/dist/lib/modules/product-page-summary/product-page-summary.action';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/page-summary/dist/lib/modules/product-page-summary/product-page-summary.action');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('product-specification')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/product-specification/dist/lib/dataActions/get-attributes-for-selected-variant';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/product-specification/dist/lib/dataActions/get-attributes-for-selected-variant');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('product-specification')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('quick-order')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('quick-order')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('quick-order')) {
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('quick-order-grid')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/quick-order-grid/dist/lib/modules/quick-order-grid/actions/get-product-list';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/quick-order-grid/dist/lib/modules/quick-order-grid/actions/get-product-list');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('quick-order-grid')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('quick-order-grid')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('quick-order-grid')) {
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('quickview')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('quickview')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('quickview')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('ratings-histogram')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/ratings-reviews/dist/lib/actions/ratings-reviews-state-data-action';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/ratings-reviews/dist/lib/actions/ratings-reviews-state-data-action');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('ratings-histogram')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-ratings-summary';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-ratings-summary');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('reviews-list')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/ratings-reviews/dist/lib/actions/get-product-reviews';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/ratings-reviews/dist/lib/actions/get-product-reviews');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('reviews-list')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/ratings-reviews/dist/lib/actions/get-user-review';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/ratings-reviews/dist/lib/actions/get-user-review');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('reviews-list')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/ratings-reviews/dist/lib/actions/ratings-reviews-state-data-action';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/ratings-reviews/dist/lib/actions/ratings-reviews-state-data-action');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('reviews-list')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-ratings-summary';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-ratings-summary');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('reviews-list')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('search')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/search-utilities/dist/lib/search-state-data-action';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/search-utilities/dist/lib/search-state-data-action');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('search-result-container')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('search-result-container')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category-hierarchy';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category-hierarchy');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('search-result-container')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('search-result-container')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('search-result-container')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/search-result-container/dist/lib/modules/search-result-container/actions/get-full-products-by-collection';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/search-result-container/dist/lib/modules/search-result-container/actions/get-full-products-by-collection');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('search-result-container')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/search-result-container/dist/lib/modules/search-result-container/actions/get-mapped-search-configuration';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/search-result-container/dist/lib/modules/search-result-container/actions/get-mapped-search-configuration');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('search-result-container')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/search-result-container/dist/lib/modules/search-result-container/actions/get-refiners-for-collection';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/search-result-container/dist/lib/modules/search-result-container/actions/get-refiners-for-collection');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('search-result-container')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/search-result-container/dist/lib/modules/search-result-container/list-page-state';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/search-result-container/dist/lib/modules/search-result-container/list-page-state');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('store-selector')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('store-selector')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-full-available-inventory-nearby';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-full-available-inventory-nearby');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('store-selector')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-store-location-information';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-store-location-information');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('tab')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/tab/dist/lib/data-actions/tab-state-data-action';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/tab/dist/lib/data-actions/tab-state-data-action');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('tab-item')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/tab/dist/lib/data-actions/tab-state-data-action';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/tab/dist/lib/data-actions/tab-state-data-action');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('wishlist-items')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('wishlist-items')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('wishlist-items')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('wishlist-items')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/wishlist/dist/lib/modules/wishlist-items/actions/get-items-in-wishlists';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/wishlist/dist/lib/modules/wishlist-items/actions/get-items-in-wishlists');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('wishlist-items')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/wishlist/dist/lib/modules/wishlist-items/actions/get-product-availabilities-wishlist-items';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/wishlist/dist/lib/modules/wishlist-items/actions/get-product-availabilities-wishlist-items');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('wishlist-items')) {
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('write-review')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/ratings-reviews/dist/lib/actions/get-user-review';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/ratings-reviews/dist/lib/actions/get-user-review');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

        if (isNotRegistered('write-review')) {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            binding.dataActions[sanitizedActionPath] = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
            

    
    } catch (e) {
        handleError('-', e);
    }
    
    return binding;
};